import "%vendor%/libs/modernizr-custom.js";
import "%js%/common/lazyload.js";
// import "%js%/common/datepicker.js";

import "%blocks%/blocks.js";